/**
 * How a person knows a bill (owner, 29 Oct): the jobs it bills, their dealer's
 * name and code, and its date. The internal claim number means nothing to a
 * reader and is never shown.
 */
export interface BillRef {
  readonly jobRefs: readonly string[];
  readonly dealers: ReadonlyArray<{ readonly name: string; readonly code: string | null }>;
  /** The invoice date, as 'YYYY-MM-DD'. */
  readonly date: string | null;
}

/** "Aaj Tak (D001)", or the name alone when the dealer has no code. */
export function dealerLabel(name: string, code: string | null | undefined): string {
  return code ? `${name} (${code})` : name;
}

/** "JOB-20261029-00001 · Aaj Tak (D001) · 29.10.2026"; `day` writes the date
 *  the way the tenant writes dates. */
export function billRefLabel(
  ref: BillRef | null | undefined,
  day: (value: string | null | undefined) => string,
): string {
  if (!ref) return '\u2014';
  const dealers = ref.dealers.map((d) => dealerLabel(d.name, d.code));
  return [ref.jobRefs.join(', '), dealers.join(', '), ref.date ? day(ref.date) : '']
    .filter(Boolean)
    .join(' \u00b7 ') || '\u2014';
}
